import { ClientRole } from '../user-access/user-access.service';
import { FormControlModel } from './form.model';

/**
 * Stepper Dialog model
 */
export interface StepperModel {
  stepID: string;
  stepLabel: string;
  placeholder?: string;
  stepper: StepperGroupModel[];
  collectiveStepper?: StepperModel[];
  leftArea?: string[];
}

/**
 * Single step/window in a stepper dialog
 * Contains groups of form fields for that step
 */
export interface StepperGroupModel {
  stepperId: string;
  stepperName: string;
  stepperGroupName: string;
  selected?: boolean;
  noValidationFlag?: boolean;
  visited?: boolean;
  formFields?: FormControlModel[];
  actions?: ActionsModel[];
  altActions?: ActionsModel[];
  disable?: boolean;
  hideHeader?: boolean;
  overrideHeader?: string;
  role?: ClientRole;
  hidden?: boolean;
}

/**
 * Action button model
 */
export interface ActionsModel {
  actionLabel: string;
  goToStep?: number;
  actionTypePosition: string;
  actionType: string;
  actionColor?: string;
  actionClass?: string;
  url?: string;
  icon?: string;
  alignIcon?: string;
  disable?: boolean;
  visible: boolean;
}
